module.exports = __webpack_public_path__ + "img/9788964372302.c64b77ca.jpg";